module.exports = __webpack_public_path__ + "img/icon_back.729d114b.svg";